import * as diacritics from "diacritics";
import _flow from "lodash/flow";
import { buildUrl, getEnv } from "shared/utils";

export function replaceApostrophes(str) {
  return str.replace(/[ʻʼ’‘`´]/g, "'");
}

const removeDiacritics = diacritics.remove;

export const cleanQuery = _flow([
  replaceApostrophes,
  removeDiacritics,
  encodeURIComponent,
]);

const SEARCH_URL = getEnv("SEARCH_URL");

export const getAutocomplete = (value) => {
  const url = buildUrl(SEARCH_URL, {
    path: "autocomplete",
    query: { q: cleanQuery(value) },
  });

  return fetch(url).then((response) => {
    // this should eventually be rolled into a utility function
    // pattern to create success / error callbacks (then/catch)
    if (response.ok) {
      return response.json();
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  });
};

export const postClickthrough = (term, id) => {
  const url = buildUrl(SEARCH_URL, "clickthrough");
  return fetch(url, {
    body: JSON.stringify({
      term,
      id,
      autocomplete: true,
    }),
    headers: new Headers({
      "Content-Type": "application/json",
      accept: "application/json",
    }),
    method: "POST",
  }).then((response) => {
    if (response.status === 204) {
      return;
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  });
};
